import { Colors } from "@jsq/ds/styles";
import { type ScreeningRecordResult } from "~/graphql/supergraphTypes";
import { textColorVariant } from "./styles_vanilla.css";
import { ScreeningStatusConfig } from "./types";

export const SCREENING_STATUS_CONFIG: Record<
  NonNullable<ScreeningRecordResult>,
  ScreeningStatusConfig
> = {
  NoMatches: {
    icon: { type: "check", color: Colors.Success600 },
    text: { content: "No matches found", variant: textColorVariant.success },
    linkText: "View",
  },
  PotentialMatches: {
    icon: { type: "exclamation-triangle", color: Colors.Warning600 },
    text: { content: "Potential match", variant: textColorVariant.warning },
    linkText: "Review",
  },
  TrueMatch: {
    icon: { type: "exclamation-circle", color: Colors.Danger600 },
    text: { content: "True match", variant: textColorVariant.danger },
    linkText: "View",
  },
  FalsePositive: {
    icon: { type: "check", color: Colors.Success600 },
    text: { content: "False positive", variant: textColorVariant.success },
    linkText: "View",
  },
};
